import { fetchJson } from 'utils/fetch';

export const getZoneById = id =>
  fetchJson(`/pco-manager/aast/zones/${id}/plan.json`);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/api/index.js